import groupPolicyPremiumRates from '../data/groupPolicyPremiumRates.json';

interface BenefitAmounts {
  [faceAmount: string]: number;
}

interface AgeRates {
  [clientAge: string]: BenefitAmounts;
}

interface AgeUnitCost {
  [clientAge: string]: number;
}

interface VbShopRates {
  'non-tobacco': AgeRates;
  'tobacco': AgeRates;
}

interface AgisRates {
  'non-tobacco': AgeUnitCost;
  'tobacco': AgeUnitCost;
}

function getVbShopMonthlyPremiumRate(
  tobaccoKey: 'tobacco' | 'non-tobacco',
  ageKey: string,
  faceAmount: string,
): number | undefined {
  const ratesData: VbShopRates = groupPolicyPremiumRates.vbShop;

  const ratesEntry = ratesData[tobaccoKey] && ratesData[tobaccoKey][ageKey];
  if (!ratesEntry) {
    return undefined;
  }

  if (ratesEntry[faceAmount]) {
    return ratesEntry[faceAmount] * 2;
  }

  // calculate base rate if benefit amount is not found
  const baseBenefitAmount = '10000';
  const baseRate = ratesEntry[baseBenefitAmount];
  if (!baseRate) {
    return undefined;
  }
  const baseRateMultiplier = parseInt(faceAmount) / parseInt(baseBenefitAmount);
  return baseRate * baseRateMultiplier * 2;
}

function getAgisMonthlyPremiumRate(
  tobaccoKey: 'tobacco' | 'non-tobacco',
  ageKey: string,
  faceAmount: string,
): number | undefined {
  const ratesData: AgisRates = groupPolicyPremiumRates.agis;

  const unitCost = ratesData[tobaccoKey] && ratesData[tobaccoKey][ageKey];
  if (!unitCost) {
    return undefined;
  }

  return (unitCost * parseInt(faceAmount)) / 1000;
}

export function getGroupPolicyPremiumRate(
  tobacco: boolean,
  clientAge: number,
  faceAmount: string,
  groupPolicyKey: 'vbShop' | 'agis',
): number | undefined {
  const tobaccoKey: 'tobacco' | 'non-tobacco' = tobacco
    ? 'tobacco'
    : 'non-tobacco';
  const ageKey = clientAge.toString();

  if (groupPolicyKey === 'vbShop') {
    return getVbShopMonthlyPremiumRate(tobaccoKey, ageKey, faceAmount);
  }

  if (groupPolicyKey === 'agis') {
    return getAgisMonthlyPremiumRate(tobaccoKey, ageKey, faceAmount);
  }

  return undefined;
}
